import { render, staticRenderFns } from "./Quitacao.vue?vue&type=template&id=515fc016"
import script from "./Quitacao.vue?vue&type=script&lang=js"
export * from "./Quitacao.vue?vue&type=script&lang=js"
import style0 from "./Quitacao.vue?vue&type=style&index=0&id=515fc016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports